import React, { FC } from 'react';
import Online from '@/components/online/Online';
import { Medium } from '@/constants/mediums';

const GasOnlinePage: FC = () => {
  return <Online medium={Medium.gas} allowMinuteData={false} />;
};

export default GasOnlinePage;
